import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Alert,
  Typography,
} from '@mui/material';
import { deleteParker } from '../../services/parkerService';

const DeleteParkerModal = ({ isOpen, onClose, parker, onParkerDeleted }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: '', message: '' });

  const handleSubmit = async () => {
    setIsLoading(true);
    setFeedback({ type: '', message: '' });
    try {
      await deleteParker(parker.parker_id);
      setFeedback({ type: 'success', message: 'Parqueadero eliminado correctamente.' });
      setTimeout(() => {
        onParkerDeleted();
        onClose();
      }, 1500);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error al eliminar el parqueadero.';
      setFeedback({ type: 'error', message: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Eliminar Parqueadero</DialogTitle>
      <DialogContent>
        <Typography>
          ¿Estás seguro de que deseas eliminar el parqueadero con ID: {parker?.parker_id}?
        </Typography>
        {feedback.message && (
          <Alert severity={feedback.type} sx={{ mt: 2 }}>
            {feedback.message}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} disabled={isLoading} color="error">
          {isLoading ? <CircularProgress size={24} /> : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteParkerModal;
